export const ADD_HISTORY = 'ADD_HISTORY';
